/**
 * price Group
 * @param fb : FormBuilder
 */
export function priceGroup (fb: any):any {
    return fb.group({
        value: [''],
        plusOrMinus: fb.group({
            percentage: ['']
        }),
        fareType: fb.control([])
    })
}
